export default "__VITE_ASSET__CC2ukmYn__"